import { snowtrade } from "../../api";

export const sendGetPropertiesRequest = (operatorId) =>
  snowtrade
    .get(`/api/property-operators/${operatorId}/properties`)
    .then((response) => response.data);
